<template>
  <vs-table hover-flat v-if="customFields && customFields.length" :data="customFields">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('custom_field_name')"></vs-th>
      <vs-th v-text="$t('options')"></vs-th>
      <vs-th class="text-center" v-text="$t('status')"></vs-th>
      <vs-th class="text-center"  v-text="$t('function')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-text="tr.name" :data-tr-title="$t('custom_field_name')"></vs-td>
        <vs-td :data-tr-title="$t('options')">
            <vs-chip v-for="option in tr.options" v-bind:key="option.id">{{option.value}}</vs-chip>
        </vs-td>
        <vs-td class="tr-flex-align-left-on-mobile">
          <div class="flex justify-center">
            <vs-switch v-model="tr.is_active" @click.prevent="$emit('badgeChangeStatus', indextr, tr.id)">
              <span slot="on">{{ $t('active') }}</span>
              <span slot="off">{{ $t('inactive') }}</span>
            </vs-switch>
          </div>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <edit-button @click="$emit('editCustomFieldPopup', tr.id)"></edit-button>&nbsp;
            <delete-button @click="$emit('deleteCustomField', tr.id)"></delete-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Configuration.Consultation.CustomFields.List',
  props: {
    customFields: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
